// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconIqsSmoothEdges_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 13L7.5 16L16 13V5.079C16 3.82847 15.2243 2.70911 14.0534 2.27001L8 0L0 3V13ZM7 13.6459V8.46177C7 7.66717 6.52961 6.94794 5.80164 6.62945L2 4.96623V11.6459L7 13.6459ZM3.97267 3.64625L8 2.136L13.3511 4.14267C13.7414 4.28904 14 4.66216 14 5.079V11.585L9 13.3497V8.46177C9 6.87257 8.05923 5.43411 6.60328 4.79714L3.97267 3.64625Z" class="svg-bg"/>
</svg>
`;
/**
 * IconIqsSmoothEdges is a generated icon component.
 */
let IconIqsSmoothEdges = IconIqsSmoothEdges_1 = class IconIqsSmoothEdges extends IconBaseElement {
    render() {
        return html `${IconIqsSmoothEdges_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconIqsSmoothEdges.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconIqsSmoothEdges = IconIqsSmoothEdges_1 = __decorate([
    customElement('zui-icon-iqs-smooth-edges')
], IconIqsSmoothEdges);
export { IconIqsSmoothEdges };
